import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
import { ModuleConfig } from "../../models/module-config.model";
let ModuleConfigService = class ModuleConfigService {
    appControllerService;
    _moduleConfigNameLookup;
    constructor(appControllerService) {
        this.appControllerService = appControllerService;
        this._moduleConfigNameLookup = new Map();
    }
    addModuleConfigName(moduleID, configName) {
        this._moduleConfigNameLookup.set(moduleID, configName);
    }
    removeModuleConfigName(moduleID) {
        return this._moduleConfigNameLookup.delete(moduleID);
    }
    getModuleConfigName(moduleID) {
        if (!moduleID) {
            throw new Error("Module ID not defined");
        }
        if (this._moduleConfigNameLookup.size <= 0) {
            throw new Error("Module config lookup empty");
        }
        return this._moduleConfigNameLookup.get(moduleID);
    }
    getCurrentlySelectedModuleConfigName() {
        if (!this.appControllerService.selectedModuleID) {
            throw new Error("Currently selected module ID not defined");
        }
        return this.getModuleConfigName(+this.appControllerService.selectedModuleID);
    }
    checkModuleName(name) {
        const currentSelectedModuleConfigName = this.getCurrentlySelectedModuleConfigName();
        if (currentSelectedModuleConfigName === name) {
            return true;
        }
        else {
            return false;
        }
    }
    isPropertyValuationModule() {
        return this.checkModuleName(ModuleConfig.PropertyValuation);
    }
    isTownPlanningModule() {
        return this.checkModuleName(ModuleConfig.TownPlanning);
    }
    isGautrainModule() {
        return this.checkModuleName(ModuleConfig.Gautrain);
    }
    isBuildingPlanModule() {
        return this.checkModuleName(ModuleConfig.BuildingPlans);
    }
    isCemeteryModule() {
        return this.checkModuleName(ModuleConfig.Cemetery);
    }
    isWayleaveModule() {
        return this.checkModuleName(ModuleConfig.Wayleaves);
    }
    isPropertyAndLeaseModule() {
        return this.checkModuleName(ModuleConfig.PropertyAndLease);
    }
    isTrainingModule() {
        return this.checkModuleName(ModuleConfig.TrainingModule);
    }
    isInformalTradeModule() {
        return this.checkModuleName(ModuleConfig.InformalTrade);
    }
    isStreetNamingModule() {
        return this.checkModuleName(ModuleConfig.StreetNaming);
    }
    isAdvertisingModule() {
        return this.checkModuleName(ModuleConfig.Advertising);
    }
    isBusinessLicenceModule() {
        return this.checkModuleName(ModuleConfig.BusinessLicence);
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
};
ModuleConfigService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ModuleConfigService);
export { ModuleConfigService };
